module.exports = __webpack_public_path__ + "img/wax.e187c929.svg";